var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcContactMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.461,
    height: 51.2,
    viewBox: "0 0 30.461 51.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-contact-mobile",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 28.961,
    height: 49.7,
    rx: 2,
    transform: "translate(0 0)",
    fill: "rgba(0,0,0,0)",
    stroke: "#022c43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 3.147,
    height: 3.147,
    rx: 0.64,
    transform: "translate(12.907 37.525)",
    fill: "rgba(0,0,0,0)",
    stroke: "#022c43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContactMobile);
export default __webpack_public_path__ + "static/media/ic-contact-mobile.a599ab91e8ae0833c565e1fc0c76c637.svg";
export { ForwardRef as ReactComponent };